module.exports = __webpack_public_path__ + "static/media/product5.dd618360.png";